module.exports = __webpack_public_path__ + "img/w3_minimize_white.10458ac7.png";